import Checkmark from '../src/Checkmark';
export default Checkmark;
